import { getAccessToken, clearAuthData } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';


export const apiClient = async (url, options = {}, requiresAuth = false) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (requiresAuth) {
      const token = getAccessToken();
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
    }

    const response = await fetch(`${API_BASE_URL}${url}`, {
      ...options,
      headers,
    });

    if (!response.ok) {
      if ((response.status === 401 || response.status === 403) && requiresAuth) {
        clearAuthData();
        window.location.href = '/admin/login';
        throw new Error('인증이 만료되었습니다. 다시 로그인해주세요.');
      }

      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        const result = await response.json();
        throw new Error(result.message || '요청 처리에 실패했습니다.');
      }

      throw new Error('서버에서 올바른 응답을 받지 못했습니다.');
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      return null;
    }

    return await response.json();
  } catch (error) {
    if (error.name === 'TypeError' && error.message === 'Failed to fetch') {
      throw new Error('서버에 연결할 수 없습니다. 네트워크 연결을 확인해주세요.');
    }

    if (error instanceof SyntaxError) {
      throw new Error('서버 응답을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.');
    }

    throw error;
  }
};